import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#314d9e',
        secondary: '#e7eaf4',
        accent: '#e9622c',
      },
    },
  },
});
